import { gql } from '@apollo/client';

export const INSERT_ROSTERS = gql`
  mutation InsertRosters($players: [rosters_insert_input!]!) {
    insert_rosters(objects: $players) {
      returning {
        id
        teamId
        playerId
      }
    }
  }
`;

export const DELETE_ROSTERS = gql`
  mutation DeleteRosters($playerIds: [Int!], $teamId: Int!) {
    delete_rosters(
      where: { playerId: { _in: $playerIds }, teamId: { _eq: $teamId } }
    ) {
      returning {
        id
      }
    }
  }
`;
